import { render } from "./fullscreenVideo.vue?vue&type=template&id=0ff5b51c"
import script from "./fullscreenVideo.vue?vue&type=script&lang=js"
export * from "./fullscreenVideo.vue?vue&type=script&lang=js"

import "./fullscreenVideo.vue?vue&type=style&index=0&id=0ff5b51c&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__